import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import client from '../api/client'
import { RootState } from '../app/store'
import { FetchStatus } from '../pages/live/types'
import { captionsSampleData } from '../pages/live/sampleData'
import { ENV } from '../app/const'

export interface Caption {
  key: string
  value: string
}

const initialState = {
  captions: [] as Caption[],
  status: 'idle' as FetchStatus,
}

export const fetchTranslations = createAsyncThunk(
  'translations/fetchCaptions',
  async () => {
    if (ENV === 'development') {
      return await JSON.parse(captionsSampleData)
    } else {
      const response = await client.post(
        '/Mobile/Pages/LiveGames.aspx/GetLiveGamesCaptions',
        {}
      )
      return await JSON.parse(response.data.d)
    }
  }
)

export const sportBonusSlice = createSlice({
  name: 'sportBonus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTranslations.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(
        fetchTranslations.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = 'succeeded'
          state.captions = [...action.payload]
        }
      )
      .addCase(fetchTranslations.rejected, (state) => {
        state.status = 'failed'
      })
  },
})

export const translationsStatus = (state: RootState) => state.translations.status
export const getCaptions = (state: RootState) => state.translations.captions
export const getCaption = (caption: string): any => {
  //createSelector(getCaptions, (c: Captions[]) => c.find((c) => (c.key = caption))?.value ?? caption)
}
export default sportBonusSlice.reducer
